import type { FaireProductEntity } from "../../entity_types/product";

export const p_kmpy98e5fy: FaireProductEntity = {
  token: "p_kmpy98e5fy",
  type: "product",
  name: "Probiotic Face Scrub | Lavender Scrub | Natural Exfoliation",
  brandToken: "b_5m0ewx9kld",
  brandName: "Elemental Wellness | Soap & Toxin-Free Living",
  imageUrl:
    "https://cdn.faire.com/fastly/42db620abc5815082eef842964eaa496621163ae9331b7a83fdb1d04e657585c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55300bfae8777e7ae5c8877ccc8148b7bca4bfe1f9921c2f4a5ccf178e148f34.png",
    "https://cdn.faire.com/fastly/128ce7be217ccfa72119920a3c16d0890d70af704686bc8817c96b3877a4caee.png",
    "https://cdn.faire.com/fastly/c02f3a90e72dd458ef0051fce4e4d8f8cc6fbb247f14799e6ff1db44ab4f3cc7.png",
    "https://cdn.faire.com/fastly/9d6cb14ce70f4d17316263a3c79ec48b885137d6ad1567ee3f8e2a0c793e1cac.png",
    "https://cdn.faire.com/fastly/bb441f1084f77e1f3a68895ae433137d1673be4835087f6487c3f5a27ae30718.png",
  ],
  priceDollars: 10.99,
  description:
    "A Gentle Exfoliation for Your Skin’s Health \n\nMade for faces that deserve love and care—not just from dirt, but from harsh chemicals too.\n\n Our probiotic face scrub is:\n* Infused with live probiotics to support your skin's microbiome\n*Gently exfoliating, nourishing, and never stripping your skin\n* Free from synthetic fragrances, parabens, sulfates, and dyes\n* Lightly scented with pure essential oils for a refreshing feel\n* Perfect for all skin types, including sensitive skin\n* Handcrafted in small batches with love and intention\n\nElemental Wellness exists to make toxin-free living easy, effective, and affordable—because protecting your body shouldn’t mean poisoning it.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:01.458Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
